import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CarritoContext } from '../../context/carritoContext'
import { useDeshabilitaCompra } from '../../hooks/deshabilitaCompra'
import Imagen from '../../imagen/Imagen'
import Precios from '../precios/Precios'
import preciosStyles from '../precios/Precios.module.css'
import { SumarProductos } from '../sumarProductos/SumarProductos'
import styles from './PublicacionSinDetalle.module.css'

export const PublicacionSinDetalle = ({ publicacion, adjunto, loadingImagenes }) => {
  const {
    idPublicacion,
    titulo,
    precioUnitario,
    monSimb,
    cantDisponible,
    alicuota,
    porcDctoVigente,
    presupuesto,
    aPedido,
    mediosPagos = []
  } = publicacion

  const [cantidad, setCantidad] = useState(1)
  const navigate = useNavigate()
  const { onAgregarCarrito, setVerCarrito, setCantidadCompra } = useContext(CarritoContext)
  const { deshabilitaCompraPorPerfil } = useDeshabilitaCompra(publicacion)
  const [deshabilitaCompra, setDeshabilitaCompra] = useState(false)

  useEffect(() => {
    const tieneMedioDePago = mediosPagos.some((medioPago) => medioPago.habilitado)
    if (!tieneMedioDePago) {
      setDeshabilitaCompra(true)
    }
  }, [idPublicacion])

  const incrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev < cantDisponible ? prev + 1 : prev))
  }
  const decrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev > 1 ? prev - 1 : 1))
  }

  const agregarAlCarrito = (e) => {
    e.stopPropagation()
    setVerCarrito(true)
    onAgregarCarrito(idPublicacion, cantidad)
    setCantidadCompra(1)
    setCantidad(1)
  }

  const pedirPresupuesto = (e) => {
    e.stopPropagation()
    navigate(`/Publicacion/${idPublicacion}`)
  }

  return (
    <div className={styles.grid}>
      <div className={styles.columnaImagen}>
        <Imagen
          idPublicacion={idPublicacion}
          width={70}
          adjunto={adjunto}
          loadingImagenes={loadingImagenes}
        />
      </div>

      <div className={styles.columnaTitulo}>
        <p className={styles.titulo}>{titulo}</p>
      </div>

      <div className={styles.columnaAccion}>
        {!presupuesto && !deshabilitaCompraPorPerfil && !aPedido && (
          <SumarProductos
            cantidad={cantidad}
            setCantidad={setCantidad}
            decrementar={decrementar}
            incrementar={incrementar}
            cantDisponible={cantDisponible}
            agregarAlCarrito={agregarAlCarrito}
            deshabilitarBoton={deshabilitaCompra}
            aPedido={aPedido}
          />
        )}
        {presupuesto && (
          <button className="btn-primary btnAccionCompra" onClick={pedirPresupuesto}>
            Pedir Presupuesto
          </button>
        )}
        {aPedido && <span className={styles.aPedido}>Publicación a pedido</span>}
      </div>

      <div className={styles.columnaPrecio}>
        {presupuesto ? (
          <span className={preciosStyles.precios__valor}>Presupuesto</span>
        ) : (
          <Precios
            precio={precioUnitario}
            monedaSimbolo={monSimb}
            alicuota={alicuota}
            porcDcto={porcDctoVigente}
            showSinIVA={true}
            className={styles.precios}
          />
        )}
      </div>
    </div>
  )
}

PublicacionSinDetalle.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    monSimb: PropTypes.string.isRequired,
    cantDisponible: PropTypes.number.isRequired,
    alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    porcDctoVigente: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    presupuesto: PropTypes.bool,
    aPedido: PropTypes.bool,
    mediosPagos: PropTypes.arrayOf(
      PropTypes.shape({
        medioPago: PropTypes.shape({
          activo: PropTypes.bool
        })
      })
    )
  }).isRequired,
  adjunto: PropTypes.object,
  loadingImagenes: PropTypes.bool.isRequired
}
